import { useMutation, useQueryClient } from 'react-query';
import { createExpense, CreateExpensePayload } from 'services/expense.service';
import { getExpensesQueryKey } from './useExpenses';

export const useCreateExpense = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: CreateExpensePayload) => createExpense(data).then((r) => r.data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(getExpensesQueryKey);
      },
    },
  );
};
